import { hardRedirectTo } from '../../../../../../../utils';
import Button from '../../../../../../generic/Button';
import Icon, { icons } from '../../../../../../generic/Icon';

type AuthSamlStepBodyProps = {
  domain: string;
};

export const AuthSamlStepBody = ({ domain }: AuthSamlStepBodyProps) => (
  <p>
    To claim the <span className="italic">{domain}</span> domain, please authenticate with your SSO configuration.
  </p>
);

type AuthSamlStepButtonsProps = {
  loginUrl: string;
};

export const AuthSamlStepButtons = ({ loginUrl }: AuthSamlStepButtonsProps) => (
  <Button onClick={() => hardRedirectTo(loginUrl)}>
    Sign in with SSO <Icon icon={icons.externalLink} />
  </Button>
);
